import React, {useContext, useEffect} from "react";
import {Checkbox, Form, FormInstance, Space} from "antd";
import {Form as MobileForm, Checkbox as MobileCheckbox} from "antd-mobile";
import {FormInstance as MobileFormInstance} from 'antd-mobile/es/components/form'
import cx from "classnames";
import {RightOutlined} from "@ant-design/icons";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import styles from "@/page-components/detail/Intro/styles.module.less";
import {DetailContext} from "@/context/detailContext";

type TMustPass = {
  isMySelfSignup?: boolean; // 是否是为自己报名
  form?: FormInstance;
  mobileFormInstance?: MobileFormInstance;
  data: {
    id: string,
    label: string;
    value: string,
    price: number;
    isPass?: boolean;
    student_price: number | null;
    supplierPrice: number | null;
  }[],
}

const MustPass: React.FC<TMustPass> = ({isMySelfSignup = true, mobileFormInstance, form, data}) => {
  const contextProps = useContext(DetailContext);
  const {userInfo} = contextProps;
  const {isPassStudentAuthentication, isOrganizationAdmin, isSupplierState} = userInfo;
  const renderPrice = (price: number, student_price: number | null, supplierPrice: number | null, isPass?: boolean) => {
    if (isPass) {
      return 0;
    }
    if (isOrganizationAdmin && isSupplierState){
      /*
      * 为自己报名：供应商管理员显示供应商价格，没有的话显示学生优惠，再没有显示原价
      * 为他人报名：没有供应商价格就显示原价
      * **/
      if (isMySelfSignup) {
        if (supplierPrice){
          return supplierPrice
        }
        if (isMySelfSignup && student_price && isPassStudentAuthentication) {
          return student_price;
        }
        return price;
      }
      return supplierPrice || price;
    }
    if (isMySelfSignup && student_price && isPassStudentAuthentication) {
      return student_price;
    }
    return price;
  }
  const renderTips = (student_price: number | null, supplierPrice:number | null, isPass?: boolean) => {
    if (isPass) {
      return <span className={styles.exam_pass_opt_grey_text}>考试已通过，无需付费</span>
    }
    if (isSupplierState && isOrganizationAdmin && supplierPrice){
      return <span className={styles.exam_pass_opt_grey_text}>享受供应商优惠价</span>
    }
    if (student_price && isMySelfSignup) {
      return isPassStudentAuthentication ? <span className={styles.exam_pass_opt_grey_text}>享受学生优惠价</span> : (
        <a href="https://fanruanclub.com/?tab=auth&type=student">
          <Space className={cx(styles.exam_pass_opt_text, styles.exam_pass_opt_student_price)}>
            <span>{`学生认证后${student_price}元`}</span>
            <RightOutlined/>
          </Space>
        </a>
      )
    }
    return '';
  }
  useEffect(() => {
    if (mobileFormInstance) {
      mobileFormInstance.setFieldsValue({must_choose: data.map(item => item.value)})
    }
    if (form) {
      form.setFieldsValue({must_choose: data.map(item => item.value)})
    }
  }, [data]);

  return (
    <>
      <PcComponentWrapper>
        <Form.Item
          className={cx(styles.row, styles.row_gap)}
          name="must_choose"
          label={<span className={styles.tips_text} >必考项目：</span>}
          rules={[{required: true}]}
        >
          <div className={styles.small_tips_text}>必须通过</div>
          <Space direction="vertical" style={{width: '100%'}} size={10}>
            {data.map(item => {
              return (
                <div key={item.id} className={cx(styles.exam_pass_opt, styles.exam_pass_opt_border)}>
                  <Space>
                    <Checkbox checked value={item.value}/>
                    <div>
                      <p className={styles.exam_pass_opt_label}>{item.label}</p>
                      <Space>
                        <span
                          className={cx(styles.exam_pass_opt_text, styles.exam_pass_opt_price)}>￥{renderPrice(item.price, item.student_price, item.supplierPrice, item.isPass)}</span>
                        {renderTips(item.student_price, item.supplierPrice, item.isPass)}
                      </Space>
                    </div>
                  </Space>
                </div>
              )
            })}
          </Space>
        </Form.Item>
      </PcComponentWrapper>
      <MobileComponentWrapper style={{width: '100%'}}>
        <MobileForm.Item
          className={cx(styles.row, styles.row_gap)}
          name="must_choose"
          label={<span className={styles.tips_text}>必考项目</span>}
          rules={[{required: true}]}
        >
          <Space size={12} direction="vertical" style={{width: 'calc(100vw - 32px)'}}>
            {data.map(item => {
              return (
                <div key={item.id} className={cx(styles.exam_pass_opt, styles.exam_pass_opt_border)}>
                  <Space>
                    <MobileCheckbox checked value={item.value}/>
                    <div>
                      <p className={styles.exam_pass_opt_label}>{item.label}</p>
                      <Space>
                        <span
                          className={cx(styles.exam_pass_opt_text, styles.exam_pass_opt_price)}>￥{renderPrice(item.price, item.student_price, item.supplierPrice, item.isPass)}</span>
                        {renderTips(item.student_price, item.supplierPrice, item.isPass)}
                      </Space>
                    </div>
                  </Space>
                </div>
              )
            })}
          </Space>
        </MobileForm.Item>
      </MobileComponentWrapper>
    </>
  )
}
export default MustPass;
